// NotFound.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    const handleNavigateHome = () => {
        navigate('/'); // Navigate back to the home page
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                height: '100%',
                width: "100%"
            }}
        >
            <Typography variant="h3" gutterBottom>
                404 - Page Not Found
            </Typography>
            <Typography variant="h6" gutterBottom>
                Sorry, the page you are looking for does not exist.
            </Typography>
            <Button variant="contained"
                // color="primary"
                onClick={handleNavigateHome}>
                Go to Home
            </Button>
        </Box>
    );
};

export default NotFound;
